import { render, staticRenderFns } from "./PaymentRemittance.vue?vue&type=template&id=44683d8c&scoped=true&"
import script from "./PaymentRemittance.vue?vue&type=script&lang=js&"
export * from "./PaymentRemittance.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRemittance.vue?vue&type=style&index=0&id=44683d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44683d8c",
  null
  
)

export default component.exports